import PassBox from './src/PassBox'

PassBox.install = function (Vue) {
    Vue.component(PassBox.name, PassBox);
};

export default PassBox;